export default __webpack_public_path__ + "static/media/antp_nom015_170ct_registro.c2f2c275.jpg";